export const clientConstants = {
    CLIENT_RESET: 'CLIENT_RESET',
    CLIENT_FETCH_COMPLETED: 'CLIENT_FETCH_COMPLETED',   
    CLIENT_SET_DATA: 'CLIENT_SET_DATA',
    CLIENT_DELETE_DATA: 'CLIENT_DELETE_DATA'
};